import React, { useState, useRef } from 'react';
// import styled from 'styled-components';
import Peer from 'peerjs' ;

export const Video = () => {
    return (
        <Call />
    )
}

const Call =() => {
    
    const peerRef = useRef();
    const video = useRef();
    const audio = useRef();
    const [onvideocall,setOnvideocall] = useState(false);
    const [onaudiocall, setOnaudiocall] = useState(false);
    const [recvid, setRecvid] = useState('');
    const [id, setId] = useState('');
    // const [audioSrc,setAudioSrc] = useState('');
    var peer;

    const peer_connect = () =>{

        //making a peer connection
        peerRef.current = new Peer();
        
        //setting id for the peer
        peerRef.current.on('open', function(id){
            setId(id);
        });

        //when peer is connected to someone elses ID
        peerRef.current.on('connection', (conn) => {
            conn.on('data', (data) => {
                console.log(data);
            })
        })

        //answering video call
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
        peerRef.current.on('call', (call) => {
            if(call.metadata.type === 'video')
            {
                navigator.getUserMedia({ video: true, audio: true }, (stream) => {
                    call.answer(stream);
                    call.on('stream' , (remoteStream) => {
                    setOnvideocall(true);
                    video.current.srcObject = remoteStream;
                    });
                }, (err) => {
                    console.log('Failed to get local stream',err);
                });
            }else if(call.metadata.type === 'audio'){
                navigator.getUserMedia({ audio: true }, (stream) => {
                    call.answer(stream); // Answer the call with an A/V stream.
                    call.on('stream', (remoteStream) => {
                      setOnaudiocall(true);
                      audio.current.srcObject = remoteStream;
                    //   setAudioSrc(remoteStream);
                    });
                  }, (err) => {
                    console.error('Failed to get local stream', err);
                  });
            }
            else{
                console.log("Refactor this");
            }
        });
    }

    // const peer_connect = () =>{
    //     peer = new Peer();
    //     peer.on('open', function(id){
    //         setId(id);
    //     });

    //     peer.on('connection', (conn) => {
    //         conn.on('data',(data) =>{
    //             console.log(data);
    //         } )
    //     })
    // }

    const sendhi =() => {

        //connecting to others ID
        const conn = peerRef.current.connect(recvid);

        //ssending messages on the peer network established
        conn.on('open', () => {
            conn.send('hi!');
        });
    }

    const videocall =() =>{
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
        navigator.getUserMedia({video: true, audio: true}, (stream) => {
            const call = peerRef.current.call(recvid, stream, { metadata: { type: 'video' } });
            call.on('stream', (remoteStream) => {
            setOnvideocall(true);
            video.current.srcObject = remoteStream;
            });
        },(err) =>{
            console.log("failed video call",err);
        })
    }
    
    const closevideocall =() => {
        setOnvideocall(false);
        video.current.srcObject=null;
    }

    const audiocall = () => {
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
        navigator.getUserMedia({ video: false, audio: true }, (stream) => {
            const call = peerRef.current.call(recvid, stream, { metadata: { type: 'audio' } });
            call.on('stream', (remoteStream) => {
                setOnaudiocall(true);
                audio.current.srcObject = remoteStream;
                // setAudioSrc(remoteStream);
            });
        }, (err) => {
            console.error('Failed to get local stream', err);
        });
    }

    const reject_audiocall = () => {
        setOnaudiocall(false);
        // setAudioSrc(null);
        audio.current.srcObject = null;
    }

    return (
        <div>
            <h1>Video Call</h1>
            <div>
                <button onClick={peer_connect}>Connect To Peerjs</button>
                <h3>Peer ID : {id}</h3>
            </div>

            <div>
                <input type="text" placeholder=" other connections id" value={recvid} onChange ={e => {setRecvid(e.target.value) }}>
                </input>
                <button onClick = { sendhi }> send hi:{recvid} </button>
                <br/>
                <br/>
                <button onClick = { videocall }>video call</button>
                <br/>
                <button onClick = { closevideocall }>Reject video call</button>
                <br/>
                <button onClick = { audiocall }> audio call </button>
                <button onClick = { reject_audiocall}>reject audio call</button>
                {onvideocall && 
                    <div>
                        <video ref={video} width="100" height="100" autoPlay =" autoplay"></video>
                    </div>
                }

                {onaudiocall &&
                    <div>
                    <audio autoPlay={true} ref={audio}></audio>
                    </div>
                }
            </div>
        </div>
    )
}


export default Video;